import { useQuery } from '@tanstack/react-query';
import { industriesQuery } from '@/lib/publicQueries';
export type { Industry } from '@/lib/publicQueries';

export const useIndustries = () => {
  return useQuery(industriesQuery());
};
